import React, { useContext, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Intro from './components/Intro';
import Type from './components/Type';
import Title from './components/Title';
import Logo from './components/Logo';
import Colors from './components/Colors';
import Home from './components/Home';
import More from './components/More';
import Header from './components/Header';
import Nav from './components/Nav';
import Finish from './components/Finish';
import { AppContext } from './AppContext';
import Disabled from './components/Error';
import { useProjectId } from './useProjectId';
import Completed from './components/Completed';

const AppRoutes: React.FC = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('AppRoutes must be used within an AppProvider');
  }

  const { appData, updateAppData } = context;
  const projectId = useProjectId(); // Obtendo o projectId com o hook

  const [isEnabled, setIsEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    const fetchProjectStatus = async () => {
      if (projectId) {
        try {
          const response = await fetch(`https://project.zas.media/api/projects/${projectId}`);
          const project = await response.json();


          if (project.data && project.data.enabled) {
            setIsEnabled(true);

            // Verificar se o projectId já está presente antes de atualizar o appData
            if (appData.id !== projectId) {
              updateAppData({
                ...appData,
                id: projectId,
              });
            }
          } else {
            setIsEnabled(false);
          }
        } catch (error) {
          console.error("Erro ao buscar o projeto:", error);
          setIsEnabled(false);
        }
      } else {
        setIsEnabled(false);
      }
    };

    // Disparando a requisição apenas quando o projectId for alterado
    if (projectId) {
      fetchProjectStatus();
    }
  }, [projectId, appData, updateAppData]); // O fetch depende de projectId, appData e updateAppData

  return (
    <div className="min-h-full">
      <Header />
      <main>
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          {isEnabled === null ? (
            <Disabled />
          ) : isEnabled ? (
            <Routes>
              <Route path="/:projectId" element={<Intro />} />
              <Route path="/:projectId/tipo" element={<Type />} />
              <Route path="/:projectId/titulo" element={<Title />} />
              <Route path="/:projectId/logo" element={<Logo />} />
              <Route path="/:projectId/cores" element={<Colors />} />
              <Route path="/:projectId/inicial" element={<Home />} />
              <Route path="/:projectId/nav" element={<Nav />} />
              <Route path="/:projectId/mais" element={<More />} />
              <Route path="/:projectId/finalizar" element={<Finish />} />
              <Route path="/:projectId/concluido" element={<Completed />} />
            </Routes>
          ) : (
            <Disabled />
          )}
        </div>
      </main>
    </div>
  );
};

export default AppRoutes;
